import { httpsCallable } from 'firebase/functions';
import { functions } from 'services/Firebase';

export const INCOME_TYPE = {
  playTime: 'playTime',
  affiliateCampaign: 'affiliateCampaign',
} as const;

export const OPERATION_MODES = {
  executeAndReport: 'executeAndReport',
  executeAndReportForce: 'executeAndReportForce',
  reportOnly: 'reportOnly',
} as const;

export const SUPPORTED_ENDPOINTS = ['get_processed_months'] as const;
type Endpoint = typeof SUPPORTED_ENDPOINTS[number];

export type Request<T = Endpoint> = {
  endpoint: T;
  endpointInput: T extends 'get_processed_months'
    ? {
        projectId: string;
        incomeType: keyof typeof INCOME_TYPE;
      }
    : never;
};

export type Response = Array<{
  date: string;
  total: number;
  artist: number;
  company: number;
  id: string;
  projectId: string;
  incomeType: keyof typeof INCOME_TYPE;
}>;

export const getSubscriptionRevenueData = httpsCallable<Request, Response>(
  functions,
  'getSubscriptionRevenueData',
);
